module.exports = __webpack_public_path__ + "static/media/merchant-profile.52737576.svg";